<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <Toasts></Toasts>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      v-model="username"
                      placeholder="Username"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      v-model="password"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        @click="handleLogin()"
                        class="px-4"
                        style="display: flex; justify-content:center; align-items: center;"
                      >
                        <div
                          v-if="loading"
                          class="sk-double-bounce bouncing2"
                          style=" margin:0 !important; width:26px; height:26px; display: inline-block;"
                        >
                          <div class="sk-child sk-double-bounce1"></div>
                          <div class="sk-child sk-double-bounce2"></div>
                        </div>

                        Login
                      </b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                        >Forgot password?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center justify-content-center">
                <img
                  class="navbar-brand-full"
                  src="img/brand/new_logo2.png"
                  width="270em"
                  height="auto"
                  alt="CoreUI Logo"
                />
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import mainNav from "../../navigation/mainNav";
import router from "../../router";
import { userTabs } from "../../shared/utils";
export default {
  components: {
    router
  },
  name: "Login",
  data: function() {
    return {
      username: "",
      password: "",
      loading: false
    };
  },
  methods: {
    choosePaths(userAccess) {
      let childrenArray = [];
      let redirectPath = "";
      if (localStorage.getItem("fns_user")) {
        for (const [key, value] of Object.entries(userAccess)) {
          if (value) {
            if (redirectPath.length === 0) {
              redirectPath = mainNav[key].route.mainRoute;
            }
            childrenArray.push(...mainNav[key].route.children);
          }
        }
      }
      return {
        childrenArray: childrenArray,
        redirectPath: redirectPath
      };
    },
    handleLogin() {
      this.loading = true;
      let params = {};
      params = {
        user: this.username,
        pass: this.password
      };
      this.$http
        .get("api/fns/auth/login.php", {
          params
        })

        .then(
          res => {
            console.log("succ");

            if (res.data.status === "SUCCESS") {
              localStorage.setItem("fns_user", res.data.fns_user_id);
              localStorage.setItem("user_tabs", JSON.stringify(res.data.tabs));
              localStorage.setItem(
                "fns_user_picture",
                res.data.fns_user_picture
              );
              localStorage.setItem("fns_full_name", res.data.fns_full_name);
              localStorage.setItem("fns_token", res.data.fns_token);
              let paths = this.choosePaths(userTabs(res.data.tabs));
              localStorage.setItem("redirect_path", "/" + paths.redirectPath);
              this.loading = false;
              if (paths) {
                router.replace({ path: "/" + paths.redirectPath });
              } else {
                router.push("/");
              }
            } else {
              this.loading = false;
              this.$toast.error("Wrong username or password");
            }
          },
          err => {
            this.loading = false;
            console.log(err);
            console.log("fail");
          }
        );
    }
  }
};
</script>
